import { render, staticRenderFns } from "./FinanceDashboardPage.vue?vue&type=template&id=8937fd7a&scoped=true"
import script from "./FinanceDashboardPage.vue?vue&type=script&lang=js"
export * from "./FinanceDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./FinanceDashboardPage.vue?vue&type=style&index=0&id=8937fd7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8937fd7a",
  null
  
)

export default component.exports